import { z } from "zod";

// The program fields the v3 editor added (#336, brief §5.0). Their own module
// for program.ts's size; program.ts re-exports them, as it does programTargets.

/** S2: what a round is for. «test» is a label only: the 1RM test stays on
 *  the cycle's last round (Q5, programResolution). */
export const RoundType = z.enum(["normal", "deload", "test"]);
export type RoundType = z.infer<typeof RoundType>;

/** S2: one type per round, length == cycleWeeks (validateRoundsAndRanges in
 *  the API). Absent: every round is normal, as on every program before it. */
export const RoundTypes = z.array(RoundType).min(1).max(12);

/** #356: what a block is for, chosen in the model's wizard. Two values, no
 *  middle one (Antenore 17/10). */
export const PROGRAM_FOCUS = ["strength", "mass"] as const;
export const ProgramFocus = z.enum(PROGRAM_FOCUS);
export type ProgramFocus = z.infer<typeof ProgramFocus>;

/** S3: the highest end a rep range takes, as `reps` itself (program.ts). */
export const REPS_RANGE_MAX = 50;

/** S3: the rep range of a set, around `reps`, which stays the target («10
 *  (8-12)»). Both or neither, min <= reps <= max, never on an AMRAP or a
 *  timed set (Q6): repsRangeProblem in programRepsRange.ts. */
export const SetRepsRange = {
  repsMin: z.number().int().min(0).max(REPS_RANGE_MAX).optional(),
  repsMax: z.number().int().min(0).max(REPS_RANGE_MAX).optional(),
};

/** #355: the highest RIR an AMRAP stop rule takes. */
export const AMRAP_STOP_RIR_MAX = 5;

/** #355: where an AMRAP set stops. `rir`: with N reps in reserve;
 *  `technical-failure`: at the first rep that breaks form. Absent: no rule
 *  written, as on every set before it. Read only on an AMRAP set. */
export const AmrapStop = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("rir"), rir: z.number().int().min(0).max(AMRAP_STOP_RIR_MAX) }),
  z.object({ kind: z.literal("technical-failure") }),
]);
export type AmrapStop = z.infer<typeof AmrapStop>;
